import { useCallback, useState } from 'react';
import type { MouseEvent } from 'react';

export function useMenu<T>() {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [item, setItem] = useState<T | null>(null);

  const openMenu = useCallback(
    (event: MouseEvent<HTMLElement>, selectedItem?: T) => {
      setAnchorEl(event.currentTarget);
      setItem(selectedItem ?? null);
    },
    []
  );

  const closeMenu = useCallback(() => {
    setAnchorEl(null);
    setItem(null);
  }, []);

  return {
    anchorEl,
    item,
    isOpen: Boolean(anchorEl),
    openMenu,
    closeMenu,
  };
}
